































































import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";
import { CompanyDetailReviewCategory } from "@/api/types";
import CompanyDetailSummary from "@/components/Pages/CompanyDetail/Molecules/CompanyDetailSummary/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Tabs from "@/components/Molecules/Tabs/index.vue";
import TabPane from "@/components/Molecules/Tabs/TabPane/index.vue";
import LoadingView from "@/components/Molecules/LoadingView/index.vue";
import ReviewRadarChart from "./Molecules/ReviewRadarChart/index.vue";
import FavoriteChart from "./Molecules/FavoriteChart/index.vue";
import ReviewContents from "@/components/Pages/CompanyDetail/Organisms/ReviewContents/index.vue";
import { CATEGORY_NAME } from "@/constants/company";
import FollowButton from "@/components/Molecules/FollowButton/index.vue";
import CompanyCompareButton from "@/components/Molecules/CompanyCompareButton/index.vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "CompanyDetail",
  components: {
    CompanyDetailSummary,
    Heading,
    Tabs,
    TabPane,
    LoadingView,
    ReviewRadarChart,
    FavoriteChart,
    ReviewContents,
    FollowButton,
    CompanyCompareButton
  },
  props: {
    loading: {
      type: Object as PropType<Props["loading"]>,
      required: true
    },
    company: {
      type: Object as PropType<Props["company"]>,
      default: undefined
    },
    review: {
      type: Array as PropType<Props["review"]>,
      required: true
    },
    isOurCompany: {
      type: Boolean as PropType<Props["isOurCompany"]>,
      required: true
    }
  },
  data() {
    return {
      activeTab: 0
    };
  },
  methods: {
    reviewCount(index) {
      return this.review[index].count;
    },
    reviewLabel(index) {
      let title: string;
      // TODO: ENTRY_SHEET の項目は今後対応
      // if (
      //   this.review[index].category === CompanyDetailReviewCategory.ENTRY_SHEET
      // ) {
      //   title = this.review[index].name;
      // } else {
      //   title = `${this.review[index].name}のクチコミ`;
      // }
      title = `${this.review[index].name}のクチコミ`;
      const sufix = `（${this.reviewCount(index)}件）`;

      return `${title}${sufix}`;
    },
    tabState(index, category) {
      return this.review[index].category === category;
    },
    clickTab() {
      switch (this.review[this.activeTab].name) {
        case CATEGORY_NAME[CompanyDetailReviewCategory.SEMINAR]:
          break;
        case CATEGORY_NAME[CompanyDetailReviewCategory.INTERN]:
          break;
        case CATEGORY_NAME[CompanyDetailReviewCategory.RECRUITMENT]:
          break;
        // TODO: ENTRY_SHEET の項目は今後対応
        // case CATEGORY_NAME[CompanyDetailReviewCategory.ENTRY_SHEET]:
        //   // TODO: GAイベント
        //   // gaEventClickReviewFinalSelectionTab(this.$gtag.event);
        //   break;
      }
    },
    handleClickFollow({ isFollow }) {
      this.$emit("clickFollow", isFollow);
    }
  }
});
